import { Breakpoints, Layout } from '@volkswagen-onehub/components-core';
import React from 'react';
import { BonoCardBackground } from '../../../shared/ui/bono-card-backgound';

export const PdfHuchaCardContainer: React.FC<{ children: React.ReactNode }> = ({ children }) => {
	return (
		<BonoCardBackground
			stretchContent
			verticalAlign="center"
			horizontalAlign="center"
			data-testid="hucha-card-container"
			wrap={{
				[Breakpoints.default]: 'never',
			}}
		>
			<Layout
				data-testid="hucha-card-layout"
				appearance={{
					[Breakpoints.default]: [
						{ name: 'popup-hucha-card-c2', columns: 7 },
						{ name: 'popup-hucha-card-c3', columns: 17 },
					],
				}}
			>
				{children}
			</Layout>
		</BonoCardBackground>
	);
};

export const PdfHuchaCardContainer2: React.FC<{ children: React.ReactNode }> = ({ children }) => {
	return (
		<BonoCardBackground
			stretchContent
			verticalAlign="center"
			horizontalAlign="center"
			data-testid="hucha-card-container"
			wrap={{
				[Breakpoints.default]: 'never',
			}}
		>
			<Layout
				data-testid="hucha-card-layout"
				appearance={{
					[Breakpoints.default]: [
						{ name: 'popup-hucha-card-c2', columns: 10 },
						{ name: 'popup-hucha-card-c3', columns: 14 },
					],
				}}
			>
				{children}
			</Layout>
		</BonoCardBackground>
	);
};
